__webpack_require__.p = "https://static-assets-ct.flixcart.com/ct/assets/resources/air-desktop-pwa/_next/";